<div class="table-responsive">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="button-items mt-3 mb-3" style="float: left;padding-left: 1%;">
            <h2>Payment Method Settings</h2>
          </div>
          <div class="button-items mt-3 mb-3" style="float: right;">
            <button class="btn btn-primary btn-sm" (click)="loadPaymentMethods(lastTableLazyLoadEvent)" pTooltip="Refresh table" appActionTooltip><i class="mdi mdi-reload"></i></button>
            <button class="btn btn-primary btn-sm" (click)="dt.clear()" pTooltip="Clear all filters and sorting" appActionTooltip>Clear <i class="mdi mdi-filter-remove"></i></button>
            <button class="btn btn-success btn-sm" (click)="addPaymentMethod()" pTooltip="Add a new payment method" appActionTooltip><i class="mdi mdi-plus"></i> Add Payment Method</button>
          </div>
        </div>
      </div>
      <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadPaymentMethods($event)" [value]="paymentMethods" dataKey="id"
        styleClass="p-datatable-tasks" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,25,50]" [loading]="loading" responsiveLayout="scroll" [paginator]="true"
        [autoLayout]="true" [totalRecords]="totalRecords" paginatorDropdownAppendTo="body"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width:6rem">View/Edit</th>
            <th pSortableColumn="accountName">
              <div class="flex justify-content-between align-items-center" style="justify-content: flex-end;">
                <span>Payment Name</span>
                <span style="display: flex; gap: 4px; align-items: center;">
                  <p-sortIcon field="accountName"></p-sortIcon>
                  <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="accountName" display="menu"></p-columnFilter>
                </span>
              </div>
            </th>
            <th pSortableColumn="type">
              <div class="flex justify-content-between align-items-center" style="justify-content: flex-end;">
                <span>Payment Type</span>
                <span style="display: flex; gap: 4px; align-items: center;">
                  <p-sortIcon field="type"></p-sortIcon>
                  <p-columnFilter matchMode="equals" [showOperator]="false" [showAddButton]="false"
                    [matchModeOptions]="matchModeOptions" type="text" field="type" display="menu">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-dropdown [ngModel]="value" [options]="typeList"
                        (onChange)="filter($event.value)" placeholder="Any">
                        <ng-template let-option pTemplate="item">
                          <span>{{option.label}}</span>
                        </ng-template>
                      </p-dropdown>
                    </ng-template>
                  </p-columnFilter>
                </span>
              </div>
            </th>
            <th pSortableColumn="glCode">
              <div class="flex justify-content-between align-items-center" style="justify-content: flex-end;">
                <span>GL Code</span>
                <span style="display: flex; gap: 4px; align-items: center;">
                  <p-sortIcon field="glCode"></p-sortIcon>
                  <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="glCode" display="menu"></p-columnFilter>
                </span>
              </div>
            </th>
            <th pSortableColumn="status">
              <div class="flex justify-content-between align-items-center" style="justify-content: flex-end;">
                <span>Status</span>
                <span style="display: flex; gap: 4px; align-items: center;">
                  <p-sortIcon field="status"></p-sortIcon>
                  <p-columnFilter matchMode="equals" [showOperator]="false" [showAddButton]="false"
                    [matchModeOptions]="matchModeOptions" type="text" field="status" display="menu">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-dropdown [ngModel]="value" [options]="statusList"
                        (onChange)="filter($event.value)" placeholder="Any">
                        <ng-template let-option pTemplate="item">
                          <span>{{option.label}}</span>
                        </ng-template>
                      </p-dropdown>
                    </ng-template>
                  </p-columnFilter>
                </span>
              </div>
            </th>

            <th pSortableColumn="createdBy">
              <div class="flex justify-content-between align-items-center" style="justify-content: flex-end;">
                <span>Created By</span>
                <span style="display: flex; gap: 4px; align-items: center;">
                  <p-sortIcon field="createdBy"></p-sortIcon>
                  <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="createdBy" display="menu"></p-columnFilter>
                </span>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-payment let-columns="columns">
          <tr>
            <td>
              <div class="flex justify-content-between align-items-center" style="gap: 8px; padding-left: 8px; padding-right: 8px;">
                <button class="btn btn-info btn-sm" pTooltip="View payment method details" appActionTooltip (click)="viewPayment(payment)" role="button"><i class="mdi mdi-eye"></i></button>
                <span appActionTooltip [pTooltip]="payment.status !== 'Active' ? 'Only active payment methods can be edited' : 'Edit payment method'" [actionDisabled]="payment.status !== 'Active'">
                  <button class="btn btn-warning btn-sm" (click)="editPayment(payment)" role="button" [disabled]="payment.status !== 'Active'"><i class="mdi mdi-pencil"></i></button>
                </span>
                <button class="btn btn-danger btn-sm" [pTooltip]="getPaymentStatusActionTooltip(payment)" appActionTooltip (click)="setPaymentStatus(payment)" role="button">
                  <i class="mdi mdi-block-helper"></i>
                </button>
              </div>
            </td>
            @for (col of columns; track col) {
              <td>
                <span style="display: flex; ">{{payment[col.field]}}</span>
              </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="cols.length + 1">
              No records found
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog [resizable]="false" [draggable]="false" [(visible)]="paymentDialog" (onHide)="closeDialog()" [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-notification [errorMsg]="errorMsg"></app-notification>
    <form [formGroup]="paymentForm">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-4">
              <div class="mb-3">
                <label class="form-label"> Payment Name <span style="color:var(--al-danger);">*</span></label>
                <input class="form-control" type="text" formControlName="accountName" [disabled]="viewOnly">
                @if (submitted && accountName && accountName.invalid) {
                  <span style="color:var(--al-danger)">Payment Name is required</span>
                }
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label class="form-label">Payment Type <span style="color:var(--al-danger);">*</span></label>
                <select class="form-select" formControlName="type" [disabled]="viewOnly">
                  <option value="" selected>Select</option>
                  @for (type of typeList; track type) {
                    <option [value]="type.value">{{type.label}}</option>
                  }
                </select>
                @if (submitted && type && type.invalid) {
                  <span style="color:var(--al-danger)">Payment Type is required</span>
                }
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label class="form-label">Status </label>
                <input class="form-control" type="text" formControlName="status" disabled>
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label class="form-label">GL Code <span style="color:var(--al-danger);">*</span></label>
                <input class="form-control" type="text" formControlName="glCode" [disabled]="viewOnly">
                @if (submitted && glCode && glCode.invalid) {
                  <span style="color:var(--al-danger)">GL Code is required</span>
                }
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label class="form-label">User(s) <span style="color:var(--al-danger);">*</span></label>
                @if (viewOnly) {
                  <app-static-multi-value [values]="getSelectedUserLabels()"></app-static-multi-value>
                } @else {
                  <p-multiSelect [maxSelectedLabels]="10000"
                    [options]="userList"
                    optionLabel="mainEmail"
                    optionValue="id"
                    formControlName="users"
                    [disabled]="viewOnly"
                    defaultLabel="Select User(s)"
                    placeholder="Select User(s)"
                    appendTo="body">
                  </p-multiSelect>
                }
                @if (submitted && paymentForm.get('users')?.invalid) {
                  <span style="color:var(--al-danger)">At least one user is required</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (!viewOnly) {
        <div class="row">
          <div class="col-xl-12">
            <div class="button-items" style="float: right;">
              @if (newPayment) {
                <a class="btn btn-primary" pTooltip="Save new payment method" appActionTooltip (click)="savePayment()"> Save @if (btnLoading) {
                  <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                }</a>
              }
              @if (!newPayment) {
                <a class="btn btn-primary" pTooltip="Save changes to payment method" appActionTooltip (click)="savePayment()"> Update @if (btnLoading) {
                  <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                }</a>
              }
              <a class="btn btn-secondary" pTooltip="Discard changes and close" appActionTooltip (click)="closeDialog()"> Cancel </a>
            </div>
          </div>
        </div>
      }
    </form>
  </ng-template>
</p-dialog>
